<template>
  <figure>
    <img :src="data.src" alt="" />
    <figcaption v-html="data.caption"></figcaption>
  </figure>
</template>

<script>

  export default {
    name: 'ContentModuleImage',
    props: {
      data: {
        type: Object,
        required: true
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  figcaption {
    @include caption;
  }
</style>



// WEBPACK FOOTER //
// src/components/_global/content-module/image.vue